
import Vue from 'vue';
import Axios from 'axios';
import { EventBus } from '@/plugins/eventBus';
import { LogIt } from '@/plugins/webApi'; 
export default Vue.extend({
  name: 'AppStore',
  data: () => ({
    headers: [
      {
        text: 'Icon',
        align: 'left',
        sortable: false,
        value: 'image',
      },
      {
        text: 'Name',
        align: 'center',
        sortable: true,
        value: 'name',
      },
    ],
    results: [],
    wait: true,
    selected: [],
  }),
  props: {
    term: {
        required: true,
        type: String,
    },
    origin: {
        required: true,
        type: String,
        default: 'US',
    },
    start: {
      required: true,
      type: Boolean,
      default: false,
    },
  },
  watch: {
    start(n: boolean, o: boolean) {
      if (n) {
        this.search();
      }
    },
    selected(n: object[], o: object[]) {
      if (n) {
        EventBus.$emit('searcher', n[0]);
      }
    },
  },
  methods: {
    search() {
      const that = this;
      const url = `https://itunes.apple.com/search?term=${encodeURI(this.term)}&country=${encodeURI(this.origin)}&media=software&limit=15`;
      Axios({ url })
      .then((resp) => {
        that.wait = false;
        if (resp.data.resultCount > 0) {
          that.results = resp.data.results.map((obj: any) => {
            return { image: obj.artworkUrl100, name: obj.trackCensoredName };
          });
          EventBus.$emit('message', { text: 'Search Successful' });
          LogIt(`(AppStore.vue)->search() ${this.term}/${this.origin} returned ${that.results.length} records`, false);
        } else {
          EventBus.$emit('message', { text: 'Search failed.. we found nothing!', context: 'warning' });
        }
      })
      .catch((err) => {
        EventBus.$emit('message', { text: `Error: ${err.message}`, context: 'error' });
        LogIt(`(AppStore.vue)->search() ${err}`, true);
      });
    },
    pop(e: EventListenerOrEventListenerObject): void {
        EventBus.$emit('searcher', e);
    },
  },
});
